module.exports = __webpack_public_path__ + "static/img/CPC.da9a4c75.png";